
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-office",
      function () {
        return require("private-next-pages/virtual-office.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-office"])
      });
    }
  